import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

import DashboardBox from 'ui/dashboard/Box';
import DashboardBoxContent from 'ui/dashboard/BoxContent';
import { ServiceStatus } from '../../consts';
import Status from './Status';

const styles = theme => ({
    root: {
        position: 'relative',
    },
    enabled: {
        cursor: 'pointer',
    },
    status: {
        position: 'absolute',
        top: theme.spacing(),
        right: theme.spacing(),
        fontWeight: 500,
        textTransform: 'uppercase',
    },
    activeStatus: {
        color: '#00a785',
    },
    inactiveStatus: {
        color: '#ff5959',
    },
    logo: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 115,
        '& img': {
            maxWidth: 260,
            maxHeight: 90,
        },
    },
});

const Box = ({ logo, label, isEnabled, status, onSelect, classes }) => {
    const rootClassName = classNames(classes.root, {
        [classes.enabled]: isEnabled,
    });
    const isActive = !!(status & ServiceStatus.ACTIVE);
    return (
        <DashboardBox>
            <DashboardBoxContent tiny>
                <div className={rootClassName} onClick={onSelect}>
                    {isActive && (
                        <Status small status={status & ServiceStatus.ENABLED} />
                    )}
                    <div className={classes.logo}>
                        <img src={logo} alt={label} />
                    </div>
                </div>
            </DashboardBoxContent>
        </DashboardBox>
    );
};
export default withStyles(styles)(Box);
